import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResizeObserverModule } from '@ng-web-apis/resize-observer';
import { DlsButtonModule } from '@zelis/dls/button';
import { DlsCardModule } from '@zelis/dls/card';
import { DlsIconModule } from '@zelis/dls/icons';
import {
  CalloutCardComponent,
  CalloutCardContentComponent,
  CalloutCardImageDirective,
} from './callout-card/callout-card.component';

@NgModule({
  imports: [
    CommonModule,
    DlsIconModule,
    DlsButtonModule,
    DlsCardModule,
    ResizeObserverModule,
  ],
  declarations: [
    CalloutCardComponent,
    CalloutCardContentComponent,
    CalloutCardImageDirective,
  ],
  exports: [
    CalloutCardComponent,
    CalloutCardContentComponent,
    CalloutCardImageDirective,
  ],
})
export class DlsCalloutCardModule {}
